import { jsx } from 'react/jsx-runtime';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(
  (theme) => ({
    text: {
      fill: theme.palette.textContrast
    }
  }),
  { name: "BackstageDependencyGraphDefaultLabel" }
);
function DefaultLabel({ edge: { label } }) {
  const classes = useStyles();
  return /* @__PURE__ */ jsx("text", { className: classes.text, textAnchor: "middle", children: label });
}

export { DefaultLabel };
//# sourceMappingURL=DefaultLabel.esm.js.map
